/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import React from 'react';

import {ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';
import * as FolderConstants from 'constants/FolderConstants';
import FolderDAO from 'file-browser/FolderDAO';
import FolderSelector from 'file-browser/FolderSelector';
import notifications, {Response} from 'notifications';
import Col from 'ui-library/bs/Col';
import FormGroup from 'ui-library/bs/FormGroup';
import FormInput from 'ui-library/bs/FormInput';
import Label from 'ui-library/bs/Label';
import Row from 'ui-library/bs/Row';
import Modal from 'ui-library/modals/Modal';

interface Props {
  onRequestClose: (...args: Array<any>) => any;
  successCallback?: (...args: Array<any>) => any;
  initialParentId?: string;
  folderType: any; // TODO: PropTypes.oneOf([FolderConstants.Type.INVENTORY, FolderConstants.Type.NOTEBOOK])
}

interface State {
  parent: string | null;
  name: string;
  description: string;
  posting: boolean;
}

class CreateFolderModal extends React.Component<Props, State> {
  static defaultProps = {
    folderType: FolderConstants.Type.INVENTORY,
  };

  _isMounted?: boolean;

  override state: State = {
    parent: this.props.initialParentId || null,
    name: '',
    description: '',
    posting: false,
  };

  override componentDidMount(): void {
    this._isMounted = true;
  }

  override componentWillUnmount(): void {
    this._isMounted = false;
  }

  createFolder = (): void => {
    this.setState({posting: true});
    FolderDAO.create({
      parent: this.state.parent,
      name: this.state.name,
      description: this.state.description,
      type: this.props.folderType,
    })
      .done((folder: FolderConstants.MinimalFolder) => {
        FolderDAO.registerCreatedFolder(folder, this.props.successCallback);
        this.props.onRequestClose();
      })
      .fail((err: Response) => {
        notifications.notifyError(err);
        if (this._isMounted) {
          this.setState({posting: false});
        }
      });
  };

  enableSubmit = (): boolean =>
    this.state.parent != null && Boolean(this.state.name.trim()) && !this.state.posting;

  override render(): JSX.Element {
    return (
      <Modal
        title="Create folder"
        onRequestClose={this.props.onRequestClose}
        onRequestSubmit={this.createFolder}
        buttons={[{text: 'Create', submit: true, disabled: !this.enableSubmit()}]}
        analyticsModule={ANALYTICS_MODULE.PROJECT_FOLDER}
        analyticsModalType="create_folder"
        analyticsMetadata={{folderType: this.props.folderType}}
      >
        <Row>
          <Col sm={7}>
            <FormGroup>
              <Label className="required">Name</Label>
              <FormInput
                value={this.state.name}
                onChange={(e: any) => {
                  this.setState({name: e.target.value});
                }}
                focusOnMount={true}
                dataTestAttrs={{component: 'CreateFolderModal', element: 'nameInput'}}
              />
            </FormGroup>
          </Col>
          <Col sm={5}>
            <FormGroup>
              <Label className="required">Location</Label>
              <FolderSelector
                enableRedesign={true}
                level="CREATE_SUBFOLDER"
                requireSubfolderCreatableAuth={true}
                showInventory={this.props.folderType === FolderConstants.Type.INVENTORY}
                showNotebook={this.props.folderType === FolderConstants.Type.NOTEBOOK}
                value={this.state.parent}
                onChange={(e) => {
                  this.setState({parent: e.target.value});
                }}
                unsetOnFetchFail={true}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <FormGroup>
              <Label>Description</Label>
              <FormInput
                value={this.state.description}
                onChange={(e: any) => {
                  this.setState({description: e.target.value});
                }}
              />
            </FormGroup>
          </Col>
        </Row>
      </Modal>
    );
  }
}

export default CreateFolderModal;
